import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

/**
 * Portal Component
 * Renders children at document.body level to avoid clipping
 */
export default function Portal({ children }) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  if (!mounted) return null;

  return createPortal(children, document.body);
}
